import(/* webpackMode: "eager" */ "/var/www/EDJR/src/app/[locale]/industries/logistics/page.tsx");
